import en from './en'
import nl from './nl'
import de from './de'

export default {
  nl,
  de,
  en
} satisfies Record<'nl' | 'de' | 'en', typeof en>
